<template>
  <div class="collection"
       :class="{ more: isMore }">
    <div class="nav clearfix">
      <ul class="options">
        <li :class="[{ active: active_idx == 0 }, 'title']"
            @click="activeFn(0)">
          标题
          <com-dropdown class="dropdown" v-bind:items="dropdown_data_title"></com-dropdown>
        </li>
        <li :class="{ active: active_idx == 1 }"
            @click="activeFn(1)">模版</li>
        <li :class="{ active: active_idx == 2 }"
            @click="activeFn(2)">图库</li>
        <li :class="{ active: active_idx == 3 }"
            @click="activeFn(3)">动图</li>
      </ul>
    </div>
    <ul class="list_content">
      <li v-for="(item, key) in itemSet"
          :key="key"
          :title="item.title"
          :data-id="item.id"
          :data-reactid="item.reactid"
          v-html="item.content"
          @click="electFn(item)"></li>
    </ul>
    <div v-show="btn_show"
         class="box_btn">
      <div v-show="isMore"
           class="less"
           @click="less_fn"></div>
      <div v-show="!isMore"
           class="more"
           @click="more_fn"></div>
    </div>
  </div>
</template>

<script>
import comDropdown from "./com-dropdown.vue";
export default {
  name: "comCollection",
  data() {
    return {
      isMore: false,
      btn_show: false,
      active_idx: 0,
      dropdown_data_title: [
        { text: "编号标题", isActive: true },
        { text: "线框标题", isActive: false },
        { text: "底色标题", isActive: false },
        { text: "图片标题", isActive: false }
      ],
      itemSet: [
        {
          content:
            '<div data-reactid=".0.0.4.2.0.0.1.0.1.1.0.0.$=1$2.0"><section class="ihuyiEditor" style="border: 0px none; box-sizing: border-box;"><section style="text-align: center;"><section style="width:3em;display: inline-block;"><img style="width: 100%;vertical-align: middle;" src="http://img.xdnphb.com/ueditor/edit/upload/image/20190130/170220/1548815662785088282.gif"></section></section></section></div>',
          title: "中国风春节中国结动态分割符2019-1-30",
          id: "3282",
          reactid: ".0.0.4.2.0.0.1.0.1.1.0.0.$=2$1"
        },
        {
          content:
            '<div data-reactid=".0.0.4.3.0.0.1.0.1.1.0.0.$=1$0.0"><section class="ihuyiEditor" style="border: 0px none; box-sizing: border-box;"><section style="text-align: center;"><section style="width:3em;display: inline-block;"><img style="width: 100%;vertical-align: middle;" src="http://img.xdnphb.com/ueditor/edit/upload/image/20190130/170220/1548815785666009746.gif"></section></section></section></div>',
          title: "中国风春节中国结动态分割符2019-1-30",
          id: "3281",
          reactid: ".0.0.4.3.0.0.1.0.1.1.0.0.$=1$2"
        }
      ]
    };
  },
  methods: {
    activeFn(idx) {
      this.active_idx = idx;
    },
    electFn(data) {
      this.$emit("add_ueditor_value", data);
    },
    more_fn() {
      this.isMore = true;
    },
    less_fn() {
      this.isMore = false;
    }
  },
  created() {
    if (window.innerWidth > 1780) {
      this.btn_show = true;
    }
  },
  components: {
    comDropdown
  }
};
</script>

<style lang="scss" scoped>
.collection {
  min-width: 385px;
  width: 385px;
  height: 100%;
  background-color: #ffffff;
  margin-right: 5px;
  color: #535353;
  position: relative;

  &.more {
    min-width: 770px;
    width: 770px;

    .list_content {
      column-count: 2;
    }
  }
  .clearfix {
    zoom: 1;
    &::after {
      content: "";
      height: 0;
      line-height: 0;
      display: block;
      visibility: hidden;
      clear: both;
    }
  }

  .options {
    position: relative;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;

    li {
      line-height: 48px;
      padding: 0 15px;
      border-bottom: 2px solid transparent;

      &:hover {
        color: $color;
        border-bottom: 2px solid $color;
      }
    }
  }

  .active {
    color: $color;
  }

  .box_btn {
    width: 37px;
    position: absolute;
    top: 50%;
    right: -40px;
    z-index: 5;
    margin-top: -77px;
    display: flex;
    justify-content: space-between;
    div {
      width: 18px;
      height: 77px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .more {
      background-image: url(../assets/images/material_more.png);
    }
    .less {
      background-image: url(../assets/images/material_less.png);
    }
  }

  .list_content {
    column-count: 1;
    column-gap: 20px;
    width: 100%;
    padding: 15px;
    box-sizing: border-box;

    li {
      cursor: pointer;
      break-inside: avoid;
      background-color: #fff;
      overflow: hidden;
      margin-bottom: 10px;
      box-sizing: border-box;
      border: 1px dotted #d9d9d9;

      &:hover {
        border: 1px solid $color;
      }
    }
  }

  .title {
    position: relative;
    .dropdown {
      position: absolute;
      left: 0;
      top: 105%;
      display: none;
    }
    &:hover .dropdown {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-collection.vue